<template>
  <ScreenshotViewer :requestID="requestID" mode="user" />
</template>

<script>
import ScreenshotViewer from './ScreenshotViewer.vue';

export default {
  name: 'UserViewImage',
  components: { ScreenshotViewer },
  props: {
    requestID: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
